import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers/store";
import "./style.scss";

const CompanyInfo = () => {
    const products = useSelector((state: RootState) => state.search.products);
    return (
        <div className="bis-company-info-container">
            <div className="bis-company-info-container-row">
                <div className="bis-company-info-container-col company-name">
                    <FormattedMessage id="main.titles.step2" />{" "}
                    <span>{products.name}</span>
                </div>
            </div>
            <div className="bis-company-info-container-row">
                <div className="bis-company-info-container-col">
                    {products.address}, {products.postal_code} {products.city}{" "}
                    {products.province}
                </div>
                <div className="bis-company-info-container-col">
                    <FormattedMessage id="widgets.companyCard.vatNumber" />{" "}
                    <span>{products.piva}</span>
                </div>
                <div className="bis-company-info-container-col">
                    <FormattedMessage id="widgets.companyCard.fiscalCode" />{" "}
                    <span>{products.fiscal_code}</span>
                </div>
                <div className="bis-company-info-container-col">
                    <FormattedMessage id="widgets.companyCard.rea" />{" "}
                    <span>{products.rea}</span>
                </div>
            </div>
        </div>
    );
};

export default CompanyInfo;
